import { render } from "./IconSearch.vue?vue&type=template&id=f002ebd0"
const script = {}

import "./IconSearch.vue?vue&type=style&index=0&id=f002ebd0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__